module.exports = __webpack_public_path__ + "static/media/IELL.a283741d.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/IELL.jpg
// module id = 1753
// module chunks = 1